"use strict";

import { GlobalParameters } from "generated"
import { toBool } from "../../lib/utils.js";
import { Basic } from "../basic.js";
import styles from './bimframe.css'
/**
 * @class MSBimFrame
 * @extends Basic
 * @classdesc Контейнер Bim модели
 * */
export class MSBimFrame extends Basic {

    static get observedAttributes() {
        return super.observedAttributes.concat(["bimmodels"]);
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        if (this.id == $WinDefs.constructor.mainFrame[window.activeMonitorTemplateId]) {
            this._pushState = true;
        }
        this.style.userSelect = "none";
        shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>

            <slot></slot>
            <div class="border border--top"></div>
            <div class="border border--right"></div>
            <div class="border border--bottom"></div>
            <div class="border border--left"></div>
        `;

        this.setInitialBordersValues();

        if (window.ipc) {
            try {
                this.pdfViewer = window.ipc.get().sendSync("server", "getPdf");
            } catch (e) { }
        }
        this._sizetocontent = 1;
        this.firstRun = true;
        this.frameHistory = [];
        //this.historyIdx = 0;
    }

    setInitialBordersValues() {
        this.style.borderWidth = 0;
        this.style.setProperty("--borderThickness", "1px");
        this.style.setProperty("--borderStyle", "solid");
        this.style.setProperty("--borderColor", "GRAY");
    }

    get borderthickness() {
        return this._borderthickness;
    }

    set borderthickness(value) {
        value = parseInt(value, 10);
        if (isNaN(value) || value < 0) {
            return;
        }
        this._borderthickness = value;
        this.style.setProperty("--borderThickness", this._setValueUnit(value));
    }

    get bordercolor() {
        return this.style.borderColor;
    }

    set bordercolor(value) {
        this.style.setProperty("--borderColor", this.tryToGetUserColor(value));
    }

    get borderstyle() {
        return this._borderstyle;
    }

    set borderstyle(value) {
        this._borderstyle = value;
        this.style.setProperty(
            "--borderStyle",
            this.getBorderStyle(window._enums.BorderStyleType[value])
        );
    }

    get isvisible() {
        return this._showElement;
    }
    set isvisible(value) {
        this._showElement = value;
        const isShow =
            (this.opacity === "" || this._toBool(this.opacity)) &&
            this._toBool(value);
        this.style.display = isShow ? "" : "none";
    }

    updateZIndex(value /*:Number*/) {
        if (value > this.contentMaxZIndex) this.contentMaxZIndex = value;
        if (this._maskElement) {
            this._maskElement.style.zIndex = this.contentMaxZIndex + 1;
        }
        this.style.setProperty("--zIndex", this.contentMaxZIndex);
    }

    get bimmodels() {
        return this._bimmodels;
    }
    set bimmodels(value) {
        this.setBm(value);
    }

    setBm(value) {
        var values = value.split('?');
        var servers = JSON.parse(GlobalParameters.globals.BimServers);
        var serv = servers[values[0]];
        var newvalue = values.length > 1 ? `${serv}?${values[1]}` : `${serv}`;        
        const iframe = `<iframe src="${newvalue}&session_id=${$sw.sessionId}" style="width:100%;height:100%;"></iframe>`;
        this.innerHTML = iframe;        
        this._bimmodels = value;
    }
}